import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface ShowTYUExperience {
  show_tyu_experience: boolean;
}

const showTyuExperience: Module<ShowTYUExperience, RootState> = {
  namespaced: true,
  state: {
    show_tyu_experience: false,
  },
  getters: {
    showTYUExperience: (state: ShowTYUExperience): boolean => state.show_tyu_experience,
  },
  mutations: {
    setValue(state: ShowTYUExperience, value: ShowTYUExperience): void {
      Object.assign(state, value);
    },
  },
};

export default showTyuExperience;
